import {useEffect} from 'react';
import {
    useNavigate,
    useParams,
} from 'react-router-dom';
import {Grid} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {RecordForm} from '../forms/RecordForm';
import {buildInitialValues} from '../forms/buildInitialValues.ts';
import {Profile} from '../profile/Profile';
import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {usePersona} from '../hooks/usePersona.ts';
import {usePersonasSelection} from '../hooks/usePersonasSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import config from '../config';

export const EditPage = () => {

    const {id} = useParams();

    if (typeof id === 'undefined') {
        throw new Error('id is required parameter');
    }

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(`${config.basePath}/${id}`);
    };

    const {
        record,
        updateRecord,
    } = usePersona(id);

    const {handleClearSelection} = usePersonasSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();

    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!record) {
        return <PlatformLoader message='Loading persona...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={record.name}
            pageNavigation={<EditPageNavigation component={record}/>}
            tools={tools}
        >
            {mode === 'view' ? (
                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 5
                    }}>
                        <Profile record={record}/>
                    </Grid.Col>
                </Grid>
            ) : (
                <RecordForm
                    record={buildInitialValues(record)}
                    handleSubmit={updateRecord}
                    handleCancel={onCancel}
                />
            )}
        </FormPageLayout>
    );
};
